<template>
  <button 
    :class="[
      $style.base,
      {
        [$style.light]: light
      }
    ]"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    light: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" module>
.base {
  display: inline-block;
  position: relative;
  min-width: 42px;
  min-height: 42px;
  font-weight: bold;
  border-radius: $radius;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color .1s ease, border-color .1s ease;
  user-select: none;
  padding: 12px $spacing;
  text-decoration: none;

  &:not(.light) {
    color: white;
    background-color: $color-main;
    border: 1px solid transparent;

    &:hover {
      color: white;
      background-color: $color-main-dark;
    }
  }

  &.light {
    background-color: white;
    border: 1px solid $color-border-input;
    color: inherit;

    &:hover {
      background-color: $color-highlight;
    }
  }
}
</style>
